/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */

import uniqBy from 'lodash/uniqBy';
import axios from 'axios';
import get from 'lodash/get';
import templates from '../configuratorTemplates';
import { trackEstimatorPageLoad } from './analytics/analyticsFunctions';
import {
  createConfiguration,
  // editConfiguration,
  executeRules
} from '../api/configuratorSettings';
import { getPreconfiguration } from './pathUtils';
import {
  APP_ACTION_SAVE_AND_CONTINUE_FAILED,
  APP_ACTION_LOAD_CONFIGURATION_FAILED,
  logNewRelicError
} from './newRelicActions';

export default ({
  extraSelections,
  onConfiguratorLoadSuccess,
  configuratorAdditionalDetails,
  config,
  storeNumber,
  onSaveConfiguration,
  afterRulesExecuted,
  configId,
  designId,
  itemId,
  totalPrice,
  selectedChoice,
  onChoiceSelectedSuccess,
  isFromSave,
  omsId,
  productId,
  setSkuDataAction,
  mainImgUrl,
  isFromEdit
}) => {

  const configurationId = configId || config.configurationId || '';
  const doNothing = () => new Promise(resolve => true); //eslint-disable-line
  function setOptionsApiUrlAndParams(baseOptionsUri) {
    const baseParams = { productId };
    if (!isFromEdit) {
      const optionsApi =
        baseOptionsUri + `/Get${omsId ? 'Parent' : ''}ConfiguratorOptionsWithExternalProductId`;
      const params = { ...baseParams };
      if (omsId) { params.externalProductId = omsId; }
      return ({ optionsApi, params });
    }
    if (configurationId && isFromEdit) {
      const optionsApi = baseOptionsUri + `/Get${omsId ? 'Parent' : ''}ConfiguratorOptions`;
      const params = { ...baseParams, configurationIdForSelections: configurationId };
      if (omsId) { params.externalProductId = omsId; }
      return ({ optionsApi, params });
    }
    // is there a scenario where we are in edit without configuration
    return {};
  }

  const {
    brand,
    eleanorBaseUrl,
    externalProductId,
    logEnsightenEventsToConsole,
    productName,
    siteId,
    storeSku,
  } = config;

  const configuratorSettings = {
    allowDeselect: false,
    templates,
    configurationId,
    productLine: '',
    productLineId: '',
    // cartOmsId: config.cartOmsId,
    customValidators: {},
    // APIs
    priceApi: doNothing,
    alwaysShowOopsMessage: true,
    oopsMessage: 'Please select from an available option',
    executeRulesApi: executeRules,
    onRulesExecuted: afterRulesExecuted,
    createConfigurationApi: (params) => {
      const { selections } = params;

      return createConfiguration(
        uniqBy([...extraSelections, ...selections], 'choiceId'),
        storeNumber,
        mainImgUrl,
        configuratorAdditionalDetails,
        totalPrice,
        productId
      );
    },
    editConfigurationApi: 'doNothing', // editConfigurationApi is never called.
    /* flooring onEdit calls createConfigurationApi as well.
      this is original call that's not used
    (params) => {
      const { selections } = params;
      return editConfiguration(
        uniqBy([...extraSelections, ...selections], 'choiceId'),
        storeNumber,
        mainImgUrl,
        configuratorAdditionalDetails,
        totalPrice,
      );
    }, */
    getOptionsApi: () => {
      const path = 'Catalog/ProductConfiguration';

      const baseOptionsUri = `${eleanorBaseUrl}/Catalog/ProductConfiguration`;
      const { optionsApi, params } = setOptionsApiUrlAndParams(baseOptionsUri);

      return axios.get(optionsApi, { params }).then((response) => {
        const superSkuOptionChoices = response?.data?.superSkuOptionChoices;
        if (omsId && Object.keys(superSkuOptionChoices).length > 0) {
          setSkuDataAction(superSkuOptionChoices);
        } else {
          logNewRelicError(
            APP_ACTION_LOAD_CONFIGURATION_FAILED, path, null, baseOptionsUri, params);
        }
        return response;
      })
        .catch((error) => {
          logNewRelicError(
            APP_ACTION_LOAD_CONFIGURATION_FAILED, path, get(error, 'status', 500), baseOptionsUri, params);
        }
        );
    },
    loadDictionaryDefinitionApi: `${eleanorBaseUrl}/DictionaryManagement/Definition/DictionaryDefinitionForTerm`,
    loadDictionaryTermsApi: `${eleanorBaseUrl}/DictionaryManagement/Definition/AllDictionaryEntries`,
    // End APIs
    siteId,
    productId,
    productName,
    storeSku,
    externalProductId,
    logEnsightenEventsToConsole,
    brand,
    userId: null,
    hiddenOptions: [982],
    mixPanelConfig: {
      timedEvent: 'PCP_TimeDevotion',
      isMixPanelActive: true,
      mixPanelCode: 'c2360a502ff32f3443acba1f20009e04',
    },
    preconfiguration: getPreconfiguration,
    persistenceKey: productId,
    eleanorBaseUrl,
    zipcode: {},
    updateConfigurationButtonText: 'Update Rug',
    addConfigurationButtonText: 'Add to Cart',
    onLoadSuccess() {
      onConfiguratorLoadSuccess(isFromSave, designId, itemId, configurationId);
      trackEstimatorPageLoad(config?.omnitureInfo);
    },
    onSaveSuccess(data) {
      onSaveConfiguration(designId, itemId, data);
    },
    onSaveFailure: (data, message) => {
      logNewRelicError(
        APP_ACTION_SAVE_AND_CONTINUE_FAILED,
        'api/designs/save',
        message,
        '',
        { designId, itemId, data, message }
      );
      /* eslint-disable no-console */
      console.error('Save Failed!');
      console.log(message);
      console.debug(data);
      /* eslint-enable no-console */
    },
    onChoiceSelectedSuccess,
    staticImages: {},
  };

  return configuratorSettings;
};
